import type { Role } from '../data/types';

export type ViewId = 'dashboard' | 'technician-reports' | 'clients' | 'client-profile' | 'schedule' | 'run-sheets' | 'map' | 'rodent' | 'calculator' | 'technicians' | 'documents' | 'compliance' | 'users';

export interface RouteDef {
  view: ViewId;
  path: string;
  title: string;
  section: string;
  /** Sidebar entry highlighted while this view is open. */
  nav: ViewId;
  roles?: Role[];
  /** Views holding expensive state (live maps, an in-progress site plan) stay mounted after the first visit. */
  keepAlive?: boolean;
}

export const ROUTES: RouteDef[] = [
  { view: 'dashboard', path: '/', title: 'Dashboard', section: 'Overview', nav: 'dashboard' },
  { view: 'technician-reports', path: '/reports/technicians', title: 'Technician reports', section: 'Overview', nav: 'dashboard', roles: ['admin', 'operations'] },
  { view: 'clients', path: '/clients', title: 'Clients', section: 'Client CRM', nav: 'clients' },
  { view: 'client-profile', path: '/clients/:id', title: 'Client profile', section: 'Client CRM', nav: 'clients' },
  { view: 'schedule', path: '/schedule', title: 'Schedule', section: 'Field operations', nav: 'schedule' },
  { view: 'run-sheets', path: '/run-sheets', title: 'Run sheets', section: 'Field operations', nav: 'run-sheets' },
  { view: 'map', path: '/service-map', title: 'Service map', section: 'Service intelligence', nav: 'map', keepAlive: true },
  { view: 'rodent', path: '/rodent-planning', title: 'Rodent planning', section: 'Site planning', nav: 'rodent', keepAlive: true },
  { view: 'calculator', path: '/chemical-calculator', title: 'Chemical calculator', section: 'Field tool', nav: 'calculator' },
  { view: 'technicians', path: '/technicians', title: 'Technicians', section: 'Operations', nav: 'technicians', roles: ['admin', 'operations'] },
  { view: 'documents', path: '/records', title: 'Records', section: 'Operations', nav: 'documents' },
  { view: 'compliance', path: '/compliance', title: 'Compliance', section: 'Operations', nav: 'compliance' },
  { view: 'users', path: '/users', title: 'Users', section: 'Operations', nav: 'users', roles: ['admin'] }
];

export const routePath = (view: ViewId) => ROUTES.find((route) => route.view === view)?.path || '/';
export const clientPath = (id: string) => `/clients/${encodeURIComponent(id)}`;
